import { z } from 'zod';
import { configSettingsSchema } from './config-settings.schema';

export const configSettingsDataSchema = z.object({
  configurationSettings: configSettingsSchema,
  settingsSourcedFromParentAccount: z.boolean(),
});

export type ConfigSettingsData = z.infer<typeof configSettingsDataSchema>;
